<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-col style="display: flex;
  flex-flow: column;
  height: 100%; padding: 0">
        <b-row style=" flex-grow : 1; margin: 0px">
        </b-row>
        <md-dialog-alert :md-close-on-esc="false" :md-click-outside-to-close="false"
                :md-active.sync="showFinish"
                :md-title="dialogTitle"
                :md-content="dialogMessage"
                         md-confirm-text="Ok"
        @md-closed="goback"/>

        <md-dialog :md-active.synch="showDenyMessage" :md-close-on-esc="false" :md-click-outside-to-close="false">
            <md-dialog-title>Ablehnungsnachricht eingeben</md-dialog-title>
            <md-dialog-content>
                <form autocomplete="on">
                    <md-field>
                        <label>Ablehnungsnachricht</label>
                        <md-textarea v-model="denyMessage" style="min-height: 150px" md-counter="200" ></md-textarea>
                    </md-field>
                </form>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button class="md-primary" @click="goback">Abbrechen</md-button>
                <md-button class="md-primary" @click="sendDeny">Mangel ablehnen</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-active.synch="showFinishDefect" :md-close-on-esc="false" :md-click-outside-to-close="false">
            <md-dialog-title>Fertigstellungsnachricht eingeben</md-dialog-title>
            <md-dialog-content>
                <form autocomplete="on">
                    <md-field>
                        <label>Fertigstellungsnachricht</label>
                        <md-textarea v-model="finishMessage" style="min-height: 150px" md-counter="200" ></md-textarea>
                    </md-field>
                </form>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button class="md-primary" @click="goback">Abbrechen</md-button>
                <md-button class="md-primary" @click="sendFinish">Mangel fertigstellen</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-active.synch="showAccept" :md-close-on-esc="false" :md-click-outside-to-close="false">
            <md-dialog-title>Mängelmeldung überarbeiten und annehmen</md-dialog-title>
            <md-dialog-content>
                <form autocomplete="on">
                    <md-field :class="titleError">
                        <label>Titel</label>
                        <md-input v-model="defectObject.title" md-counter="50" autofocus required @focus="clearErrorTitle"></md-input>
                        <span class="md-helper-text">Pflichtfeld</span>
                        <span class="md-error">Bitte vergeben Sie einen Titel.</span>
                    </md-field>
                    <md-field :class="messageError">
                        <label>Mangelbescheibung</label>
                        <md-textarea v-model="defectObject.message" style="min-height: 150px" md-counter="500" required @focus="clearErrorMessage"></md-textarea>
                        <span class="md-helper-text">Pflichtfeld</span>
                        <span class="md-error">Bitte vergeben Sie eine Mangelbescheibung.</span>
                    </md-field>
                    <md-field>
                        <label>Fertigstellungsnachricht</label>
                        <md-textarea v-model="acceptMessage" style="min-height: 150px" md-counter="200" ></md-textarea>
                    </md-field>
                </form>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button class="md-primary" @click="goback">Abbrechen</md-button>
                <md-button class="md-primary" @click="sendAccept">Mangel annehmen</md-button>
            </md-dialog-actions>
        </md-dialog>
    </b-col>
</template>

<script>

    import {Server_URL_MAENGELMELDER} from "../shared/utils";

    export default {
        name: "MangelControl",
        mounted() {
            this.commune = this.$route.params.id;
            this.anfrage = this.$route.query.anfrage;
            this.defect  = this.$route.query.defect;
            this.action  = this.$route.query.action;
            this.user  = this.$route.query.user;

            switch (this.action) {
                case "accept":
                    this.showLoader();
                    this.$http.get(
                        Server_URL_MAENGELMELDER + '/mm/data/defect/' + this.$route.params.id + "?defect_id=" + this.defect,
                    ).then(this.responseOkGet, this.responseError)
                    this.showAccept = true;
                    break;
                case "deny":
                    this.showDenyMessage = true;
                    break;
                case "finish":
                    this.showFinishDefect = true;
                    break;
            }
        },
        data() {
            return {
                commune: "",
                anfrage: "",
                defect: "",
                action: "",
                user: "",
                showFinish: false,
                showDenyMessage: false,
                denyMessage: "Ihre Mängelmeldung wurde von Ihrer Kommune abgelehnt.",
                error: false,
                showAccept: false,
                acceptMessage: "Ihre Mängelmeldung wird nun bearbeitet.\nSobald der Mangel behoben wurde, wird Ihnen eine Fertigstellungsmeldung zugesandt.",
                defectObject: {title: "", message: ""},
                showFinishDefect: false,
                finishMessage: "Ihre Kommune meldet, dass der von Ihnen gemeldete Mangel nun behoben ist.\nVielen Dank für Ihre Mithilfe.",
                titleInvalid: false,
                messageInvalid: false,
            }
        },
        computed: {
            dialogTitle () {
                if (this.error) {
                    return "Fehler"
                } else {
                    switch (this.action) {
                        case "accept":
                            return "Mangelannahme";
                        case "deny":
                            return "Mangelrückweisung";
                        case "finish":
                            return "Mangelfertigstellung";
                    }
                }
            },
            dialogMessage () {
                if (this.error) {
                    return "Die gewünschte Aktion konnte nicht ausgeführt werden. Bitte wenden Sie sich an Ihren Systemadministrator."
                } else {
                    switch (this.action) {
                        case "accept":
                            return "Die Mangelanfrage wurde erfolgreich akzeptiert und kann von Ihnen zu einem späteren Zeitpunkt als fertiggestellt gemeldet werden.";
                        case "deny":
                            return "Die Mangelanfrage wurde erfolgreich abgelehnt.";
                        case "finish":
                            return "Die Mangelanfrage wurde erfolgreich als fertiggestellt gemeldet.";
                    }
                }
            },
            titleError () {
                return {
                    'md-invalid': this.titleInvalid
                }
            },
            messageError () {
                return {
                    'md-invalid': this.messageInvalid
                }
            },
        },
        methods: {
            showLoader() {
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            sendDeny() {
                this.showDenyMessage = false;
                this.showLoader();
                this.$http.post(
                    Server_URL_MAENGELMELDER + '/mm/data/control/' + this.$route.params.id + "?action=" + this.action + "&anfrage=" + this.anfrage + "&defect=" + this.defect + "&user=" + this.user,
                    {
                        message: this.denyMessage,
                        defect_title: "",
                        defect_message: "",
                    }
                ).then(this.responseOkFinish, this.responseError)
            },
            sendAccept() {
                if (this.checkInputs()) {
                    return;
                }
                this.showLoader();
                this.$http.post(
                    Server_URL_MAENGELMELDER + '/mm/data/control/' + this.$route.params.id + "?action=" + this.action + "&anfrage=" + this.anfrage + "&defect=" + this.defect + "&user=" + this.user,
                    {
                        message: this.acceptMessage,
                        defect_title: this.defectObject.title,
                        defect_message: this.defectObject.message,
                    }
                ).then(this.responseOkFinish, this.responseError)
            },
            sendFinish() {
                this.showLoader();
                this.$http.post(
                    Server_URL_MAENGELMELDER + '/mm/data/control/' + this.$route.params.id + "?action=" + this.action + "&anfrage=" + this.anfrage + "&defect=" + this.defect + "&user=" + this.user,
                    {
                        message: this.finishMessage,
                        defect_title: "",
                        defect_message: "",
                    }
                ).then(this.responseOkFinish, this.responseError)
            },
            responseError(response) {
                this.showAccept = false;
                this.showFinishDefect = false;
                this.showDenyMessage = false;
                this.hideLoader();
                this.error = true;
                this.showFinish = true;
                if (response.status === 401) {
                    console.log(response);
                } else {
                    console.log(response);
                }
            },
            responseOkFinish(response) {
                this.showAccept = false;
                this.showFinishDefect = false;
                this.showDenyMessage = false;
                this.hideLoader();
                if (response.status === 200) {
                    this.showFinish = true;
                } else {
                    console.log(response);
                }
            },
            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200) {
                    this.defectObject = response.body;
                } else {
                    console.log(response);
                }
            },
            goback() {
                window.close();
            },
            checkInputs() {
                let invalid = false;

                if (this.defectObject.title === "" || this.defectObject.title.trim() === "") {
                    this.titleInvalid = true;
                    invalid = true;
                } else {
                    this.titleInvalid = false;
                }

                if (this.defectObject.message === "" || this.defectObject.message.trim() === "") {
                    this.messageInvalid = true;
                    invalid = true;
                } else {
                    this.messageInvalid = false;
                }

                return invalid;
            },
            clearErrorTitle() {
                this.titleInvalid = false;
            },
            clearErrorMessage() {
                this.messageInvalid = false;
            },
        },
    }
</script>

<style scoped>
    @import '../../node_modules/vue-material/dist/vue-material.min.css';
    @import '../../node_modules/vue-material/dist/theme/default.css';

    .hoverable-icon:hover {
        cursor: pointer;
    }

</style>
